import { c as _c } from "react/compiler-runtime";
import { splitHighlights } from '@/features/payload-cms/search/search-text';
import { cn } from '@/utils/tailwindcss-override';
import React from 'react';

/** The text with every searched word marked, so a reader sees why a result was found. */
export const HighlightedText: React.FC<{
  text: string;
  words: string[];
  /** on a brand-green surface, like the chosen row of the instant search */
  onDark?: boolean;
}> = t0 => {
  const $ = _c(8);
  const {
    text,
    words,
    onDark: t1
  } = t0;
  const onDark = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onDark || $[1] !== text || $[2] !== words) {
    let t3;
    if ($[4] !== onDark) {
      t3 = (part, index) => part.isMatch ? <mark key={index} className={cn("rounded-[3px] px-px font-semibold", onDark ? "bg-white/25 text-white" : "bg-tint-line text-heading")}>{part.text}</mark> : <React.Fragment key={index}>{part.text}</React.Fragment>;
      $[4] = onDark;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = splitHighlights(text, words).map(t3);
    $[0] = onDark;
    $[1] = text;
    $[2] = words;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <>{t2}</>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};